/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Checkout_FailedInputs */

const en_pricing_checkout_failed = /** @type {(inputs: Pricing_Checkout_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to open checkout page`)
};

const es_pricing_checkout_failed = /** @type {(inputs: Pricing_Checkout_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo abrir la pagina de pago`)
};

/**
* | output |
* | --- |
* | "Failed to open checkout page" |
*
* @param {Pricing_Checkout_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_checkout_failed = /** @type {((inputs?: Pricing_Checkout_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Checkout_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_checkout_failed(inputs)
	return es_pricing_checkout_failed(inputs)
});